export default {"src":"/_next/static/media/dish.8f3379f6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};